"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginState = void 0;
const react_1 = __importStar(require("react"));
const svg_components_1 = require("@/assets/svg-components");
const Typography_1 = require("../../UI/Typography");
const useOnOutsideClick_1 = require("@/Hooks/useOnOutsideClick");
const style = __importStar(require("./styled"));
const Input_1 = __importStar(require("../../UI/Input/Input"));
const Button_1 = __importDefault(require("../../Button"));
const Hooks_1 = require("@/Hooks");
const Types_1 = require("Types");
const user_1 = require("@/Endpoints/user");
const user_2 = require("@/Redux/Actions/user");
const react_redux_1 = require("react-redux");
const Modal_1 = __importDefault(require("../../UI/Modal"));
const useInitialData_1 = __importDefault(require("../../../Hooks/useInitialData"));
const react_router_1 = require("react-router");
const useHeaderData_1 = __importDefault(require("../../../Hooks/useHeaderData"));
const loginModal_1 = require("@/Redux/Actions/loginModal");
const request_1 = require("@/Endpoints/request");
const Constants_1 = require("app/Constants");
const Utils_1 = require("app/Utils");
const loginShipToCoordinator_1 = require("@/Utils/loginShipToCoordinator");
var LoginState;
(function (LoginState) {
    LoginState["LOGIN"] = "login";
    LoginState["RESET_PASSWORD"] = "resetPassword";
    LoginState["EMAIL_SENT"] = "emailSent";
})(LoginState = exports.LoginState || (exports.LoginState = {}));
const LoginModal = ({ setIsOpen, resetPassword }) => {
    var _a;
    const { useRedirect, refreshPage } = (0, react_redux_1.useSelector)((state) => state.loginModal);
    const isNorthAmerica = (0, react_redux_1.useSelector)((state) => state.initialData.isNorthAmerica);
    const [email, setEmail] = (0, react_1.useState)('');
    const [password, setPassword] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)('');
    const [userName, setUserName] = (0, react_1.useState)('');
    const [state, setState] = (0, react_1.useState)(() => (resetPassword ? LoginState.RESET_PASSWORD : LoginState.LOGIN));
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const initialData = (0, useInitialData_1.default)();
    const headerData = (0, useHeaderData_1.default)();
    const history = (0, react_router_1.useHistory)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, Hooks_1.useTranslate)();
    const registerFormLink = (_a = initialData === null || initialData === void 0 ? void 0 : initialData.pages) === null || _a === void 0 ? void 0 : _a.registrationPage;
    const wrapperRef = (0, react_1.useRef)(null);
    const closeModal = () => {
        setIsOpen ? setIsOpen(false) : dispatch((0, loginModal_1.setIsLoginModalOpen)(false));
    };
    (0, useOnOutsideClick_1.useOnOutsideClick)(wrapperRef, closeModal);
    const getRedirectLocation = (roles) => {
        if (roles && roles.includes(isNorthAmerica ? Types_1.UserRoles.NA_DISTRIBUTORS : Types_1.UserRoles.EU_DISTRIBUTORS)) {
            return initialData.pages.myHaldexPage;
        }
        else {
            return headerData.LogoUrl;
        }
    };
    const redirectHandler = (roles) => {
        if (useRedirect) {
            history.push(getRedirectLocation(roles));
        }
        else {
            dispatch((0, loginModal_1.setLoginModalState)({ isLoginModalOpen: false, useRedirect: true, refreshPage: false }));
            if (refreshPage) {
                window.location.reload();
            }
        }
    };
    const handleLogin = (e) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        e.preventDefault();
        if (email && password) {
            setIsLoading(true);
            const loginResponse = yield (0, user_1.loginUser)(email, password);
            if (loginResponse.successful) {
                const expirationInMinutes = loginResponse.expirationInMinutes || 60;
                localStorage.setItem(Constants_1.LocalStorage.EXPIRATION_IN_MINUTES, expirationInMinutes.toString());
                const expirationTime = Date.now() + loginResponse.expirationInMinutes * 60 * 1000;
                localStorage.setItem(Constants_1.LocalStorage.EXPIRATION_TIME, expirationTime.toString());
                (0, Utils_1.deleteCookie)(Constants_1.Cookies.IS_SHIPTO_ADDED);
                const shipToSyncResult = yield (0, loginShipToCoordinator_1.syncSingleShipToAfterLogin)();
                if (shipToSyncResult.isSingleShipToDetected && !shipToSyncResult.isSuccess) {
                    setError(shipToSyncResult.errorMessage || 'Could not set ship-to account. Please try again.');
                    setIsLoading(false);
                    return;
                }
                setError('');
                yield dispatch((0, user_2.fetchUserData)());
                closeModal();
                redirectHandler((_b = loginResponse === null || loginResponse === void 0 ? void 0 : loginResponse.user) === null || _b === void 0 ? void 0 : _b.roles);
            }
            else {
                setError(loginResponse.errorMessage);
            }
            setIsLoading(false);
        }
        else {
            setError(t('/haldex/login_modal/not_all_fields_submited'));
        }
    });
    const handleForgotPassword = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        setError('');
        const result = yield (0, user_1.sendResetPassword)(userName);
        if (result === request_1.ResponseTypes.OK) {
            setState(LoginState.EMAIL_SENT);
        }
        else {
            setError(t('/haldex/login_modal/no_user_matched'));
        }
    });
    const handleSubmit = (e) => {
        switch (state) {
            case LoginState.LOGIN:
                return handleLogin(e);
            case LoginState.RESET_PASSWORD:
                return handleForgotPassword(e);
            case LoginState.EMAIL_SENT:
                return closeModal();
            default:
                return handleLogin(e);
        }
    };
    const getSignUpText = () => {
        if (registerFormLink) {
            if (isNorthAmerica) {
                return t('/haldex/login_modal/no_account_na');
            }
            else {
                return t('/haldex/login_modal/no_account_eu');
            }
        }
        else {
            if (isNorthAmerica) {
                return t('/haldex/login_modal/no_register_link_na');
            }
            else {
                return t('/haldex/login_modal/no_register_link_eu');
            }
        }
    };
    const getTitle = () => {
        switch (state) {
            case LoginState.LOGIN:
                return t('/haldex/login_modal/title');
            case LoginState.RESET_PASSWORD:
                return t('/haldex/login_modal/reset_password');
            case LoginState.EMAIL_SENT:
                return t('/haldex/login_modal/email_sent_title');
            default:
                return t('/haldex/login_modal/title');
        }
    };
    return (react_1.default.createElement(Modal_1.default, null,
        react_1.default.createElement(style.LoginContainer, { ref: wrapperRef },
            react_1.default.createElement(style.IconContainer, null,
                react_1.default.createElement(style.IconButton, { "aria-label": t('/haldex/attributes/aria-label/close'), onClick: closeModal },
                    react_1.default.createElement(style.CloseIcon, null))),
            react_1.default.createElement(style.MainContainer, { onSubmit: e => handleSubmit(e) },
                error && (react_1.default.createElement(style.ErrorContainer, null,
                    react_1.default.createElement(svg_components_1.RedWarningIcon, null),
                    react_1.default.createElement(style.ErrorText, { dangerouslySetInnerHTML: {
                            __html: error
                        }, type: Typography_1.Types.BODY_2 }))),
                react_1.default.createElement(style.Title, { type: Typography_1.Types.INTRODUCTORY_TEXT }, getTitle()),
                state === LoginState.LOGIN ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Input_1.default, { label: t('/haldex/login_modal/input_username'), value: email, setValue: value => setEmail(value.toString()), focus: true }),
                    react_1.default.createElement(style.InputContainer, null,
                        react_1.default.createElement(Input_1.default, { label: t('/haldex/login_modal/input_password'), type: Input_1.InputTypes.PASSWORD, value: password, setValue: value => setPassword(value.toString()) }),
                        react_1.default.createElement(Button_1.default, { variant: Types_1.ButtonVariants.ONLY_TEXT, onClick: () => setState(LoginState.RESET_PASSWORD), type: Types_1.ButtonTypes.BUTTON },
                            react_1.default.createElement(style.ButtonText, { type: Typography_1.Types.BODY_1 }, t('/haldex/login_modal/forgot_password')))))) : state === LoginState.RESET_PASSWORD ? (react_1.default.createElement("div", null,
                    !resetPassword && (react_1.default.createElement(style.IconButton, { "aria-label": t('/haldex/attributes/aria-label/back'), onClick: () => setState(LoginState.LOGIN) },
                        react_1.default.createElement(svg_components_1.FeatherArrowIconSmall, null))),
                    react_1.default.createElement(style.InputContainer, null,
                        react_1.default.createElement(Input_1.default, { label: t('/haldex/login_modal/input_username'), value: userName, setValue: value => setUserName(value.toString()) })))) : (state === LoginState.EMAIL_SENT && (react_1.default.createElement(style.EmailSentText, { type: Typography_1.Types.BODY_1 }, t('/haldex/login_modal/email_sent_text')))),
                react_1.default.createElement(style.ButtonContainer, null,
                    react_1.default.createElement(style.SubmitButton, { type: Types_1.ButtonTypes.SUBMIT, disabled: isLoading || (state === LoginState.RESET_PASSWORD && !userName) }, state === LoginState.LOGIN
                        ? t('/haldex/login_modal/login_button')
                        : state === LoginState.RESET_PASSWORD
                            ? t('/haldex/login_modal/send_reset_email')
                            : state === LoginState.EMAIL_SENT
                                ? t('/haldex/login_modal/okay')
                                : t('/haldex/login_modal/continue'))),
                state === LoginState.LOGIN && (react_1.default.createElement(style.NoAccountContainer, null,
                    react_1.default.createElement(style.SignupText, { type: Typography_1.Types.BODY_1, addMargin: !!registerFormLink }, getSignUpText()),
                    registerFormLink && (react_1.default.createElement(style.SignupLink, { href: registerFormLink, onClick: closeModal }, t('/haldex/login_modal/sign_up')))))))));
};
exports.default = LoginModal;
